import React, { useState } from "react";
import "../styles/RegComp.css";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import { useNavigate } from "react-router-dom";
import BackArrow from "../icons/BusinessHub/BackArrow.js";
import Vendor from "../icons/BusinessHub/VendorRegIcon.js";
import Delivery from "../icons/BusinessHub/DeliveryRegIcon.js";
import { useEffect } from "react";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon.js";
import CustomDropdown from "./StatusDropdown.js";

function RegComp() {
  const navigate = useNavigate();
  const [active, setActive] = useState("A");
  const [selectedType, setSelectedType] = useState(""); // vendor | delivery
  const [userType, setUserType] = useState(""); // company | independent

  const handleSaveAndCont = () => {
    if (!selectedType || !userType) return;
    if (userType === "Delivery Company") {
      navigate("/add-delivery-comp", {
        state: { selectedType, userType },
      });
    }
    if (userType === "Independent Driver") {
      navigate("/add-indep-driver", {
        state: { selectedType, userType },
      });
    }
  };

  const handleBusinessType = (type) => {
    setSelectedType(type);

    if (type === "delivery") {
      setActive("B");
    }
  };
  useEffect(() => {
    if (active === "B") {
      setUserType("");
    }
  }, [active]);

  return (
    <div className="add-comp-screen-container">
      <div
      // className="add-comp-page-header"
      >
        <BusinessHubHeader />
      </div>
      <div className="add-comp-content-main-container">
        {/* {UserAdd && (
          <div className="edit-user-popup-container">
            <div
              className="edit-user-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-user-popup-content">
                <div className="edit-user-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-user-successfully-added-text">
                  User Details Updated Successfully
                </div>
                <div
                  className="edit-user-successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", {
                      state: { active: "C" },
                    })
                  }
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )} */}
        <div className="add-comp-content-container">
          <div className="add-comp-header">
            <div className="add-comp-header-navigation">
              <div
                className="add-comp-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", {
                    state: { active: "A" },
                  })
                }
              >
                <BackArrow />
              </div>
              <div className="add-comp-header-navigation-text">
                Back to Business Overview
              </div>
            </div>
            <div className="add-comp-header-text">
              <div className="add-comp-header-title">Add Company</div>
              <div className="add-comp-header-text-note">
                Create a new company by selecting your type.
              </div>
            </div>
          </div>
          <div className="add-comp-body">
            {active === "A" && (
              <div className="add-comp-window-container-select">
                <div className="add-comp-select-busines-type">
                  <div className="add-comp-select-type-cont">
                    <div
                      className="add-comp-select-vendor"
                      onClick={() => navigate("/add-vendor")}
                    >
                      <div
                        className={`select-business-type-vendor ${
                          selectedType === "vendor" ? "selected" : ""
                        }`}
                        onClick={() => handleBusinessType("vendor")}
                      >
                        <div className="add-comp-select-vendor-icon">
                          <Vendor />
                        </div>
                        <div className="add-comp-select-type">Vendor</div>
                        <div className="add-comp-select-type-text">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing
                          elit, sed diam nonummy nibh euismod tincidunt
                        </div>
                      </div>
                    </div>
                    <div
                      className="add-comp-select-vendor"
                      // onClick={() => setUsertypeDiv(true)}
                    >
                      <div
                        className={`add-comp-select-delivery-container ${
                          selectedType === "delivery" ? "selected" : ""
                        }`}
                        onClick={() => handleBusinessType("delivery")}
                      >
                        <div className="add-comp-select-delivery-icon">
                          <Delivery />
                        </div>
                        <div className="add-comp-select-type">Delivery</div>
                        <div className="add-comp-select-type-text">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing
                          elit, sed diam nonummy nibh euismod tincidunt
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {active === "B" && (
              <div className="add-comp-window-container">
                <div className="add-comp-select-user-type">
                  <div className="add-comp-select-user-type-header">
                    <div className="add-comp-select-user-type-header-title">
                      User Type <div className="required">*</div>
                    </div>
                    <CustomDropdown
                      rightIcon={<ArrowDownIcon />}
                      value={userType}
                      onChange={setUserType}
                      placeholder="Select your user type"
                      options={[
                        {
                          label: "Delivery Company",
                          value: "Delivery Company",
                        },
                        {
                          label: "Independent Driver",
                          value: "Independent Driver",
                        },
                      ]}
                      className="add-comp-select-user-type-input-container"
                      menuClassName="add-comp-status-drop-menu-container"
                      optionClassName="add-comp-status-drop-menu-option"
                    />
                  </div>
                  <div className="add-comp-select-user-type-footer">
                    <div
                      className="add-comp-select-user-type-save-button"
                      onClick={() => handleSaveAndCont()}
                    >
                      Save & Continue
                    </div>
                    <div
                      className="add-comp-select-user-cancel"
                      onClick={() => setActive("A")}
                    >
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegComp;
